import { connect } from "vuex-connect";
import { StarContentsList } from "../../../components";

export default connect({
  stateToProps: {
    starContentsList: state => state.starred.starContentsList,
    starContentsCount: state => state.starred.starContentsCount
  },
  gettersToProps: {
    getOnWallBookCount: "starred/getOnWallBookCount",
    getOnWallPanelCount: "starred/getOnWallPanelCount"
  },
  actionsToProps: {
    deleteFromStarContentsList: (dispatch, value) => {
      return dispatch("starred/deleteFromStarContentsList", value);
    },
    deleteContentsOnWall: (dispatch, value) =>
      dispatch("myWalls/deleteContentsOnWall", { positionIndex: value })
  },
  mutationsToProps: {
    updateStarContentsList: (commit, value) =>
      commit("starred/updateStarContentsList", value)
  }
})(StarContentsList.name, StarContentsList);
